"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _I18n = _interopRequireDefault(require("I18n"));

var _react = _interopRequireWildcard(require("react"));

var _emptyFunction = _interopRequireDefault(require("react-utils/emptyFunction"));

var _classnames = _interopRequireDefault(require("classnames"));

var _EngagementTypes = require("customer-data-objects/engagement/EngagementTypes");

var _InteractionRecord = _interopRequireDefault(require("customer-data-objects/interaction/InteractionRecord"));

var _ProfileObjectTypesType = _interopRequireDefault(require("customer-data-objects-ui-components/propTypes/ProfileObjectTypesType"));

var _SubjectType = _interopRequireDefault(require("customer-data-objects-ui-components/propTypes/SubjectType"));

var _Interactions = require("customer-data-communicator/schema/communicator/interaction/Interactions");

var _ComponentMethods = require("customer-data-ui-utilities/component/ComponentMethods");

var _getIn = _interopRequireDefault(require("transmute/getIn"));

var _PassthruRtePlugins = _interopRequireDefault(require("customer-data-communicator/lib/draftjs/config/PassthruRtePlugins"));

var _GlobalInteractionEventTypes = require("customer-data-communicator/schema/interactions/GlobalInteractionEventTypes");

var _isInitialContentChange = require("customer-data-communicator/lib/draftjs/calculation/isInitialContentChange");

var _reactImmutableProptypes = _interopRequireDefault(require("react-immutable-proptypes"));

var _immutable = require("immutable");

var propTypes = {
  children: _react.PropTypes.node,
  connectDropTarget: _react.PropTypes.func,
  editorState: _react.PropTypes.object,
  hasRteContent: _react.PropTypes.bool,
  interaction: _react.PropTypes.instanceOf(_InteractionRecord.default).isRequired,
  isFullScreen: _react.PropTypes.bool,
  NotificationAreaComponent: _react.PropTypes.func,
  notificationAreaProps: _react.PropTypes.object,
  objectType: _ProfileObjectTypesType.default.isRequired,
  onCancel: _react.PropTypes.func.isRequired,
  onCompleteSave: _react.PropTypes.func.isRequired,
  onInteractionEvent: _react.PropTypes.func.isRequired,
  onRteChange: _react.PropTypes.func.isRequired,
  onRteRestore: _react.PropTypes.func,
  onRteStateCreated: _react.PropTypes.func.isRequired,
  onSave: _react.PropTypes.func.isRequired,
  paddingClassName: _react.PropTypes.string.isRequired,
  renderTray: _react.PropTypes.func,
  passthruRtePlugins: _react.PropTypes.instanceOf(_PassthruRtePlugins.default).isRequired,
  RichTextEditor: _react.PropTypes.instanceOf(Function).isRequired,
  RichTextEditorDefaultConfigurations: _react.PropTypes.object.isRequired,
  saveLabel: _react.PropTypes.node,
  subject: _SubjectType.default,
  useTertiaryButtons: _react.PropTypes.bool,
  saveTooltip: _react.PropTypes.shape({
    open: _react.PropTypes.bool,
    onClose: _react.PropTypes.func,
    placement: _react.PropTypes.string,
    headingText: _react.PropTypes.string,
    title: _react.PropTypes.string,
    use: _react.PropTypes.string,
    disabled: _react.PropTypes.bool
  }),
  associations: _reactImmutableProptypes.default.map,
  onInteractionChange: _react.PropTypes.func,
  onPreventNavigation: _react.PropTypes.func,
  onSaveToLocalStorage: _react.PropTypes.func
};
var defaultProps = {
  NotificationAreaComponent: null,
  notificationAreaProps: {},
  onInteractionEvent: _emptyFunction.default,
  paddingClassName: '',
  passthruRtePlugins: new _PassthruRtePlugins.default(),
  onInteractionChange: _emptyFunction.default,
  onPreventNavigation: _emptyFunction.default,
  onSaveToLocalStorage: _emptyFunction.default
};

var Note =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(Note, _Component);

  function Note(props) {
    var _this;

    (0, _classCallCheck2.default)(this, Note);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Note).call(this, props));
    (0, _ComponentMethods.bindHandlers)((0, _assertThisInitialized2.default)(_this));
    var _props$interaction$me = props.interaction.metadata,
        metadata = _props$interaction$me === void 0 ? (0, _immutable.Map)() : _props$interaction$me;
    _this.state = {
      hasContent: metadata.get('body')
    };
    return _this;
  }

  (0, _createClass2.default)(Note, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      var _this2 = this;

      this.initRteConfig();
      this.isInitialContentChange = (0, _isInitialContentChange.isInitialContentChange)(function () {
        return _this2.props.onInteractionEvent(_GlobalInteractionEventTypes.INITIAL_COMMUNICATOR_CONTENT_ENTRY, {
          interactionType: 'note'
        });
      });
    }
  }, {
    key: "initRteConfig",
    value: function initRteConfig() {
      var passthruRtePlugins = this.props.passthruRtePlugins;
      this.rteConfig = this.props.RichTextEditorDefaultConfigurations.createRteConfig(passthruRtePlugins.getRteConfigType(_EngagementTypes.NOTE), passthruRtePlugins.plugins, passthruRtePlugins.pluginComposers);
    }
  }, {
    key: "handleSave",
    value: function handleSave(rteResults) {
      var _this$props = this.props,
          onSave = _this$props.onSave,
          onCompleteSave = _this$props.onCompleteSave,
          isFullScreen = _this$props.isFullScreen;

      if (isFullScreen) {
        this.props.onInteractionEvent(_GlobalInteractionEventTypes.FLOATING_COMMUNICATOR_FULLSCREEN_SAVE, {
          type: _EngagementTypes.NOTE
        });
      }

      var interactionRecord = (0, _Interactions.createInteractionRecord)(rteResults);
      this.props.onPreventNavigation(false);
      this.setState({
        hasContent: false
      });
      onCompleteSave();
      onSave(interactionRecord);
    }
  }, {
    key: "handleRteChange",
    value: function handleRteChange(rteResults) {
      this.rteResults = rteResults;
      this.props.onRteChange(rteResults);

      if (this.rteResults.contentChanged) {
        this.isInitialContentChange(this.rteResults, rteResults);
        var rteResultsHasContent = this.rteResults && this.rteResults.hasContent();

        if (this.state.hasContent !== rteResultsHasContent) {
          this.setState({
            hasContent: rteResultsHasContent
          });
        }

        var interaction = (0, _Interactions.createLocalInteractionRecord)(this.rteResults);
        this.props.onInteractionChange({
          interaction: interaction,
          savable: rteResultsHasContent
        });
        this.props.onPreventNavigation(rteResultsHasContent);
      }
    }
  }, {
    key: "handleSaveToLocalStorage",
    value: function handleSaveToLocalStorage() {
      var interaction = (0, _Interactions.createLocalInteractionRecord)(this.rteResults);
      this.props.onSaveToLocalStorage({
        interaction: interaction
      });
    }
  }, {
    key: "handleRteStateCreated",
    value: function handleRteStateCreated(rteResults) {
      var _this$props2 = this.props,
          interaction = _this$props2.interaction,
          onRteRestore = _this$props2.onRteRestore,
          onRteStateCreated = _this$props2.onRteStateCreated;
      var body = (0, _getIn.default)(['metadata', 'body'], interaction);
      this.rteResults = rteResults;
      onRteStateCreated(rteResults);

      if (body) {
        onRteRestore(body);
      }
    }
  }, {
    key: "handleCancel",
    value: function handleCancel() {
      this.setState({
        hasContent: false
      });
      this.props.onPreventNavigation(false);
      this.props.onCancel();
    }
  }, {
    key: "renderRte",
    value: function renderRte() {
      var _this$props3 = this.props,
          RichTextEditor = _this$props3.RichTextEditor,
          editorState = _this$props3.editorState,
          paddingClassName = _this$props3.paddingClassName,
          NotificationAreaComponent = _this$props3.NotificationAreaComponent,
          notificationAreaProps = _this$props3.notificationAreaProps,
          hasRteContent = _this$props3.hasRteContent,
          subject = _this$props3.subject,
          objectType = _this$props3.objectType,
          useTertiaryButtons = _this$props3.useTertiaryButtons,
          saveTooltip = _this$props3.saveTooltip,
          renderTray = _this$props3.renderTray,
          associations = _this$props3.associations;

      var cancelLabel = _I18n.default.text('customerDataCommunicator.Communicator.Note.cancelLabel');

      var placeholder = _I18n.default.text('customerDataCommunicator.Communicator.Note.placeholder');

      var saveLabel = this.props.saveLabel || _I18n.default.text('customerDataCommunicator.Communicator.Note.saveLabel');

      var inputClassName = (0, _classnames.default)(paddingClassName, 'communicator-rte-input');
      return _react.default.createElement(RichTextEditor, {
        associations: associations,
        renderTray: renderTray,
        ControlsAreaComponent: NotificationAreaComponent,
        cancelLabel: cancelLabel,
        className: "communicator-rte-wrapper p-top-3",
        config: this.rteConfig,
        controlSize: "small",
        controlsAreaComponentProps: notificationAreaProps,
        editorState: editorState,
        focus: !hasRteContent,
        inputClassName: inputClassName,
        onCancel: this.handleCancel,
        onChange: this.handleRteChange,
        onSave: this.handleSave,
        onStateCreated: this.handleRteStateCreated,
        placeholder: placeholder,
        resetInitialStateOnSave: false,
        saveDisabled: !this.state.hasContent,
        saveLabel: saveLabel,
        saveTooltip: saveTooltip,
        showCancel: false,
        showControls: true,
        showControlsBorder: !useTertiaryButtons,
        showRTEBorder: useTertiaryButtons,
        subject: subject,
        objectType: objectType,
        useTertiaryButtons: useTertiaryButtons,
        useStickyControls: true,
        onPluginCloseModal: this.handleSaveToLocalStorage
      }, _react.default.createElement("div", {
        className: paddingClassName
      }, this.props.children));
    }
  }, {
    key: "render",
    value: function render() {
      var connectDropTarget = this.props.connectDropTarget;
      return connectDropTarget ? this.props.connectDropTarget(_react.default.createElement("div", {
        className: "communicator-rte-wrapper",
        onBlur: this.handleSaveToLocalStorage
      }, this.renderRte())) : this.renderRte();
    }
  }]);
  return Note;
}(_react.Component);

Note.propTypes = propTypes;
Note.defaultProps = defaultProps;
var _default = Note;
exports.default = _default;
module.exports = exports.default;